import React from 'react';
import jsPDF from 'jspdf';
// jspdf-autotable 5 ya no le cuelga autoTable al prototipo de jsPDF:
// hay que llamar a la funcion con el doc (doc.autoTable no existe).
import autoTable from 'jspdf-autotable';

const ReporteRecepcionMatricula = {
  /**
   * Genera un reporte PDF de recepción de matrícula
   * @param {Object} datosMatricula - Datos de la matrícula entregada
   * @param {string} datosMatricula.chasis - Número de chasis
   * @param {string} datosMatricula.nombres - Nombres del cliente
   * @param {string} datosMatricula.apellidos - Apellidos del cliente
   * @param {string} datosMatricula.cedula - Cédula del cliente
   * @param {string} datosMatricula.fecha - Fecha de entrega
   * @param {string} datosMatricula.sucursal - Sucursal de entrega
   * @param {string} datosMatricula.cajero - Cajero que entregó
   * @param {string} datosMatricula.localizacion - Localización
   * @param {Object} datosPago - Datos del pago (opcional)
   * @param {string} datosPago.valor - Valor pagado
   * @param {string} datosPago.fecha - Fecha de pago
   * @param {string} datosPago.recibido - Recibido por
   */
  generarReporte: (datosMatricula, datosPago = null) => {
    const doc = new jsPDF();
    
    // Configuración del documento
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 20;
    
    // Nombre de la empresa
    doc.setFontSize(16);
    doc.setFont(undefined, 'bold');
    doc.text(localStorage.getItem("nombrenegocio") || "", pageWidth / 2, 20, { align: 'center' });
    
    // Título del reporte
    doc.setFontSize(18);
    doc.setFont(undefined, 'bold');
    doc.text('RECEPCIÓN DE MATRÍCULA', pageWidth / 2, 30, { align: 'center' });
    
    // Línea separadora
    doc.setLineWidth(0.5);
    doc.line(margin, 35, pageWidth - margin, 35);
    
    // Información de la empresa
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text('Sistema de Gestión', pageWidth / 2, 45, { align: 'center' });
    doc.text('Fecha de generación: ' + new Date().toLocaleDateString(), pageWidth / 2, 52, { align: 'center' });
    
    // Información del chasis
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text('INFORMACIÓN DEL VEHÍCULO', margin, 70);
    
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text(`Chasis: ${datosMatricula.chasis || 'N/A'}`, margin, 80);
    
    // Información del cliente
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text('INFORMACIÓN DEL CLIENTE', margin, 95);
    
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal'); 
    doc.text(`Nombres: ${datosMatricula.nombres || 'N/A'}`, margin, 105);
    doc.text(`Apellidos: ${datosMatricula.apellidos || 'N/A'}`, margin, 112);
    doc.text(`Cédula: ${datosMatricula.cedula || 'N/A'}`, margin, 119);
    
    // Información de entrega
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text('INFORMACIÓN DE ENTREGA', margin, 135);
    
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text(`Fecha de entrega: ${datosMatricula.fecha || 'N/A'}`, margin, 145);
    doc.text(`Sucursal: ${datosMatricula.sucursal || 'N/A'}`, margin, 152);
    doc.text(`Entregado por: ${datosMatricula.cajero || 'N/A'}`, margin, 159);
    doc.text(`Localización: ${datosMatricula.localizacion || 'N/A'}`, margin, 166);
    
    // Información de pago (si existe)
    if (datosPago) {
      doc.setFontSize(14);
      doc.setFont(undefined, 'bold');
      doc.text('INFORMACIÓN DE PAGO', margin, 185);
      
      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      doc.text(`Valor pagado: $${datosPago.valor || 'N/A'}`, margin, 195);
      doc.text(`Fecha de pago: ${datosPago.fecha || 'N/A'}`, margin, 202);
      doc.text(`Recibido por: ${datosPago.recibido || 'N/A'}`, margin, 209);
    }
    
    // Firma y sello
    doc.setFontSize(12);
    doc.setFont(undefined, 'bold');
    doc.text('FIRMA DEL CLIENTE', margin, 230);
    doc.text('_________________________', margin, 240);
    doc.text('Nombre y Cédula', margin, 250);
    
    doc.text('SELLO DE LA EMPRESA', pageWidth - 80, 230);
    doc.text('_________________________', pageWidth - 80, 240);
    doc.text('Fecha: _______________', pageWidth - 80, 250);
    
    // Pie de página
    doc.setFontSize(8);
    doc.setFont(undefined, 'normal');
    doc.text('Este documento certifica la entrega de la matrícula del vehículo.', pageWidth / 2, 280, { align: 'center' });
    
    // Generar y descargar el PDF
    const nombreArchivo = `Recepcion_Matricula_${datosMatricula.chasis || 'N/A'}_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(nombreArchivo);
  },

  /**
   * Genera un reporte PDF con tabla de datos
   * @param {Object} datosMatricula - Datos de la matrícula
   * @param {Array} datosPagos - Array de datos de pagos
   */
  generarReporteConTabla: (datosMatricula, datosPagos = []) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 20;
    
    doc.setFontSize(18);
    doc.setFont(undefined, 'bold');
    doc.text(localStorage.getItem("nombrenegocio") || "", pageWidth / 2, 30, { align: 'center' });
    
    // Línea separadora
    doc.setLineWidth(0.5);
    doc.line(margin, 35, pageWidth - margin, 35);
    
    
    // Título
    doc.setFontSize(18);
    doc.setFont(undefined, 'bold');
    doc.text('RECEPCIÓN DE MATRÍCULA', 105, 20, { align: 'center' });
    
    // Información básica
    doc.setFontSize(12);
    doc.setFont(undefined, 'normal');
    doc.text(`Chasis: ${datosMatricula.chasis || 'N/A'}`, 20, 40);
    doc.text(`Cliente: ${datosMatricula.nombres || ''} ${datosMatricula.apellidos || ''}`, 20, 50);
    doc.text(`Cédula: ${datosMatricula.cedula || 'N/A'}`, 20, 60);
    doc.text(`Fecha de entrega: ${datosMatricula.fecha || 'N/A'}`, 20, 70);
    
    
    // Tabla de pagos si existen
    if (datosPagos && datosPagos.length > 0) {
      const tableData = datosPagos.map(pago => [
        pago.fecha || 'N/A',
        pago.valor || 'N/A',
        pago.recibido || 'N/A',
        pago.descripcion || 'N/A'
      ]);
      
      autoTable(doc, {
        startY: 85,
        head: [['Fecha', 'Valor', 'Recibido por', 'Descripción']],
        body: tableData,
        theme: 'grid',
        headStyles: { fillColor: [41, 128, 185] },
        styles: { fontSize: 8 }
      });
    }
    
    // Firma
    const yFirma = doc.lastAutoTable ? doc.lastAutoTable.finalY : 85;
    doc.setFontSize(12);
    doc.setFont(undefined, 'bold');
    doc.text('FIRMA DEL CLIENTE', 20, yFirma + 20);
    doc.text('_________________________', 20, yFirma + 30);
    
    const nombreArchivo = `Recepcion_Matricula_${datosMatricula.chasis || 'N/A'}_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(nombreArchivo);
  },

  /**
   * Genera un reporte PDF y lo muestra en el navegador
   * @param {Object} datosMatricula - Datos de la matrícula entregada
   * @param {Object} datosPago - Datos del pago (opcional)
   */
  mostrarReporteEnNavegador: (datosMatricula, datosPago = null) => {
    const doc = new jsPDF();
    
    // Configuración del documento
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 20;
    

    doc.setFontSize(18);
    doc.setFont(undefined, 'bold');
    doc.text(localStorage.getItem("nombrenegocio") || "", pageWidth / 2, 30, { align: 'center' });
    
    // Línea separadora
    doc.setLineWidth(0.5);
    doc.line(margin, 35, pageWidth - margin, 35);
    
    
    // Título del reporte
    doc.setFontSize(18);
    doc.setFont(undefined, 'bold');
    doc.text('REPORTE DE RECEPCIÓN DE MATRÍCULA', pageWidth / 2, 30, { align: 'center' });
    
    // Línea separadora
    doc.setLineWidth(0.5);
    doc.line(margin, 35, pageWidth - margin, 35);
    
    // Información de la empresa
    doc.setFontSize(12);
    doc.setFont(undefined, 'normal');
    doc.text(localStorage.getItem("nombrenegocio") || "", pageWidth / 2, 45, { align: 'center' });
    doc.text('Fecha de generación: ' + new Date().toLocaleDateString(), pageWidth / 2, 52, { align: 'center' });
    
    // Información del chasis
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text('INFORMACIÓN DEL VEHÍCULO', margin, 70);
    
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text(`Chasis: ${datosMatricula.chasis || 'N/A'}`, margin, 80);
    
    // Información del cliente
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text('INFORMACIÓN DEL CLIENTE', margin, 95);
    
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text(`Nombres: ${datosMatricula.nombres || 'N/A'}`, margin, 105);
    doc.text(`Apellidos: ${datosMatricula.apellidos || 'N/A'}`, margin, 112);
    doc.text(`Cédula: ${datosMatricula.cedula || 'N/A'}`, margin, 119);
    
    // Información de entrega
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text('INFORMACIÓN DE ENTREGA', margin, 135);
    
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text(`Fecha de entrega: ${datosMatricula.fecha || 'N/A'}`, margin, 145);
    doc.text(`Sucursal: ${datosMatricula.sucursal || 'N/A'}`, margin, 152);
    doc.text(`Entregado por: ${datosMatricula.cajero || 'N/A'}`, margin, 159);
    doc.text(`Localización: ${datosMatricula.localizacion || 'N/A'}`, margin, 166);
    
    // Información de pago (si existe)
    if (datosPago) {
      doc.setFontSize(14);
      doc.setFont(undefined, 'bold');
      doc.text('INFORMACIÓN DE PAGO', margin, 185);
      
      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      doc.text(`Valor pagado: $${datosPago.valor || 'N/A'}`, margin, 195);
      doc.text(`Fecha de pago: ${datosPago.fecha || 'N/A'}`, margin, 202);
      doc.text(`Recibido por: ${datosPago.recibido || 'N/A'}`, margin, 209);
    }
    
    // Firma y sello
    doc.setFontSize(12);
    doc.setFont(undefined, 'bold');
    doc.text('FIRMA DEL CLIENTE', margin, 230);
    doc.text('_________________________', margin, 240);
    doc.text('Nombre y Cédula', margin, 250);
    
    doc.text('SELLO DE LA EMPRESA', pageWidth - 80, 230);
    doc.text('_________________________', pageWidth - 80, 240);
    doc.text('Fecha: _______________', pageWidth - 80, 250);
    
    // Pie de página
    doc.setFontSize(8);
    doc.setFont(undefined, 'normal');
    doc.text('Este documento certifica la entrega de la matrícula del vehículo.', pageWidth / 2, 280, { align: 'center' });
    
    // Convertir PDF a blob y abrir en nueva ventana
    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    
    // Abrir PDF en nueva ventana/pestaña
    const nuevaVentana = window.open(pdfUrl, '_blank');
    
    // Limpiar la URL después de un tiempo para liberar memoria
    setTimeout(() => {
      URL.revokeObjectURL(pdfUrl);
    }, 10000);
    
    // Si el navegador bloquea la ventana emergente, mostrar mensaje
    if (!nuevaVentana) {
      alert('Por favor, permita ventanas emergentes para ver el PDF, o descargue el archivo manualmente.');
    }
  },

  /**
   * Genera un reporte PDF y retorna la URL para usar en un modal
   * @param {Object} datosMatricula - Datos de la matrícula entregada
   * @param {Object} datosPago - Datos del pago (opcional)
   * @returns {string} URL del PDF generado
   */
  generarReporteParaModal: (datosMatricula, datosPago = null) => {
    const doc = new jsPDF();
    
    // Configuración del documento
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 20;
    
    // Nombre de la empresa
    doc.setFontSize(16);
    doc.setFont(undefined, 'bold');
    doc.text(localStorage.getItem("nombrenegocio") || "", pageWidth / 2, 20, { align: 'center' });
    
    // Título del reporte
    doc.setFontSize(18);
    doc.setFont(undefined, 'bold');
    doc.text('RECEPCIÓN DE DOCUMENTOS', pageWidth / 2, 30, { align: 'center' });
    
    // Línea separadora
    doc.setLineWidth(0.5);
    doc.line(margin, 35, pageWidth - margin, 35);
    
    // Información de la empresa
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text('Sistema de Gestión', pageWidth / 2, 45, { align: 'center' });
    doc.text('Fecha de generación: ' + new Date().toLocaleDateString(), pageWidth / 2, 52, { align: 'center' });
    
    // Información del chasis
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text('INFORMACIÓN DEL VEHÍCULO', margin, 70);
    
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text(`Chasis: ${datosMatricula.chasis || 'N/A'}`, margin, 80);
    
    // Información del cliente
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text('INFORMACIÓN DEL CLIENTE', margin, 95);
    
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text(`Nombres: ${datosMatricula.nombres || 'N/A'}`, margin, 105);
    doc.text(`Apellidos: ${datosMatricula.apellidos || 'N/A'}`, margin, 112);
    doc.text(`Cédula: ${datosMatricula.cedula || 'N/A'}`, margin, 119);
    
    // Información de entrega
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text('INFORMACIÓN DE ENTREGA', margin, 135);
    
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text(`Fecha de entrega: ${datosMatricula.fecha || 'N/A'}`, margin, 145);
    doc.text(`Sucursal: ${datosMatricula.sucursal || 'N/A'}`, margin, 152);
    doc.text(`Entregado por: ${datosMatricula.cajero || 'N/A'}`, margin, 159);
    doc.text(`Localización: ${datosMatricula.localizacion || 'N/A'}`, margin, 166);
    
    // Información de pago (si existe)
    if (datosPago) {
      doc.setFontSize(14);
      doc.setFont(undefined, 'bold');
      doc.text('INFORMACIÓN DE PAGO', margin, 185);
      
      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      doc.text(`Valor pagado: $${datosPago.valor || 'N/A'}`, margin, 195);
      doc.text(`Fecha de pago: ${datosPago.fecha || 'N/A'}`, margin, 202);
      doc.text(`Recibido por: ${datosPago.recibido || 'N/A'}`, margin, 209);
    }
    
    // Firma y sello
    doc.setFontSize(12);
    doc.setFont(undefined, 'bold');
    doc.text('FIRMA DEL CLIENTE', margin, 230);
    doc.text('_________________________', margin, 240);
    doc.text('Nombre y Cédula', margin, 250);
    
    doc.text('SELLO DE LA EMPRESA', pageWidth - 80, 230);
    doc.text('_________________________', pageWidth - 80, 240);
    doc.text('Fecha: _______________', pageWidth - 80, 250);
    
    // Pie de página
    doc.setFontSize(8);
    doc.setFont(undefined, 'normal');
    doc.text('Este documento certifica la entrega de la matrícula del vehículo.', pageWidth / 2, 280, { align: 'center' });
    
    // Convertir PDF a blob y crear URL
    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    
    return pdfUrl;
  },

  /**
   * Genera un reporte PDF para múltiples documentos y retorna la URL para usar en un modal
   * @param {Array} documentosParaReporte - Array de documentos para el reporte
   * @returns {string} URL del PDF generado
   */
  generarReporteMultipleParaModal: (documentosParaReporte) => {
    const doc = new jsPDF();
    
    // Configuración del documento
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 20;
    
    // Nombre de la empresa
    doc.setFontSize(16);
    doc.setFont(undefined, 'bold');
    doc.text(localStorage.getItem("nombrenegocio") || "", pageWidth / 2, 20, { align: 'center' });
    
    // Título del reporte
    doc.setFontSize(18);
    doc.setFont(undefined, 'bold');
    doc.text('RECEPCIÓN DE DOCUMENTOS', pageWidth / 2, 30, { align: 'center' });
    
    // Línea separadora
    doc.setLineWidth(0.5);
    doc.line(margin, 35, pageWidth - margin, 35);
    
    // Información de la empresa
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text('Sistema de Gestión', pageWidth / 2, 45, { align: 'center' });
    doc.text('Fecha de generación: ' + new Date().toLocaleDateString(), pageWidth / 2, 52, { align: 'center' });
    
    let yPosition = 70;
    
    // Procesar cada documento
    documentosParaReporte.forEach((documento, index) => {
      // Verificar si necesitamos una nueva página
      if (yPosition > 250) {
        doc.addPage();
        yPosition = 20;
      }
      
      // Título del documento
      doc.setFontSize(12);
      doc.setFont(undefined, 'bold');
      doc.text(`DOCUMENTO PARA ENTREGA ${documento.documentosparaentrega}`, margin, yPosition);
      yPosition += 10;
      
      // Información del vehículo
      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      doc.text(`Chasis: ${documento.chasis || 'N/A'}`, margin, yPosition);
      yPosition += 8;
      
      // Información del cliente
      doc.text(`Cliente: ${documento.nombres || ''} ${documento.apellidos || ''}`, margin, yPosition);
      yPosition += 8;
      doc.text(`Cédula: ${documento.cedula || 'N/A'}`, margin, yPosition);
      yPosition += 8;
      
      // Información de entrega
      doc.text(`Fecha: ${documento.fecha || 'N/A'}`, margin, yPosition);
      yPosition += 8;
      doc.text(`Sucursal: ${documento.sucursal || 'N/A'}`, margin, yPosition);
      yPosition += 8;
      doc.text(`Cajero: ${documento.cajero || 'N/A'}`, margin, yPosition);
      yPosition += 8;
      
      // Información de pagos si existen
      if (documento.pagos && documento.pagos.length > 0) {
        doc.setFontSize(9);
        doc.setFont(undefined, 'bold');
        doc.text('PAGOS:', margin, yPosition);
        yPosition += 6;
        
        documento.pagos.forEach(pago => {
          doc.setFontSize(8);
          doc.setFont(undefined, 'normal');
          doc.text(`- Valor: $${pago.valor || 'N/A'} | Fecha: ${pago.fecha || 'N/A'}`, margin + 5, yPosition);
          yPosition += 5;
        });
      }
      
      // Línea separadora entre documentos
      if (index < documentosParaReporte.length - 1) {
        doc.setLineWidth(0.3);
        doc.line(margin, yPosition + 5, pageWidth - margin, yPosition + 5);
        yPosition += 15;
      }
    });
    
    // Firma y sello en la última página
    doc.setFontSize(12);
    doc.setFont(undefined, 'bold');
    doc.text('FIRMA DEL CLIENTE', margin, yPosition + 20);
    doc.text('_________________________', margin, yPosition + 30);
    doc.text('Nombre y Cédula', margin, yPosition + 40);
    
    doc.text('SELLO DE LA EMPRESA', pageWidth - 80, yPosition + 20);
    doc.text('_________________________', pageWidth - 80, yPosition + 30);
    doc.text('Fecha: _______________', pageWidth - 80, yPosition + 40);
    
    // Pie de página
    doc.setFontSize(8);
    doc.setFont(undefined, 'normal');
    doc.text('Este documento certifica la entrega de las matrículas de los vehículos.', pageWidth / 2, yPosition + 60, { align: 'center' });
    
    // Convertir PDF a blob y crear URL
    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    
    return pdfUrl;
  },

  /**
   * Recibo de una entrega de documentos al cliente (un LOTE: N chasis a una
   * misma persona). Reemplaza a generarPDFMultiple, que repetía los datos de
   * quien recibe por cada chasis y dibujaba la firma en un `y` acumulado, de
   * modo que con muchos chasis se salía de la hoja. Aquí el receptor se
   * imprime una sola vez, los chasis van en una tabla que pagina sola y la
   * firma se baja de página si no cabe.
   *
   * @param {Object} datos
   * @param {Object} datos.receptor - {nombres, apellidos, cedula}
   * @param {string} datos.fecha - Fecha de entrega (dd/mm/yyyy)
   * @param {string} datos.sucursal - Sucursal de entrega
   * @param {string} datos.cajero - Usuario que entrega
   * @param {string} datos.lote - Identificador del lote (para reimprimir)
   * @param {Array} datos.filas - [{chasis, vehiculo, placa, documentos}]
   * @param {Array} datos.pagos - Cobros de matrícula (opcional, informativo)
   * @returns {string} URL del PDF para el modal
   */
  generarReciboEntrega({ receptor = {}, fecha = '', sucursal = '', cajero = '', lote = '', filas = [], pagos = [] }) {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 20;

    doc.setFontSize(16);
    doc.setFont(undefined, 'bold');
    doc.text(localStorage.getItem("nombrenegocio") || "", pageWidth / 2, 20, { align: 'center' });

    doc.setFontSize(18);
    doc.text('ENTREGA DE DOCUMENTOS', pageWidth / 2, 30, { align: 'center' });

    doc.setLineWidth(0.5);
    doc.line(margin, 35, pageWidth - margin, 35);

    // Quien recibe: una sola vez, aunque el lote traiga veinte chasis.
    const cliente = [receptor.nombres, receptor.apellidos].filter(Boolean).join(' ');
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text(`Recibe: ${cliente || 'N/A'}`, margin, 45);
    doc.text(`Cédula: ${receptor.cedula || 'N/A'}`, margin, 52);
    doc.text(`Fecha: ${fecha || 'N/A'}`, pageWidth / 2, 45);
    doc.text(`Sucursal: ${sucursal || 'N/A'}`, pageWidth / 2, 52);
    doc.text(`Entregado por: ${cajero || 'N/A'}`, margin, 59);
    if (lote) {
      doc.setFontSize(8);
      doc.text(`Lote: ${lote}`, pageWidth - margin, 59, { align: 'right' });
    }

    autoTable(doc, {
      startY: 66,
      head: [['#', 'Chasis', 'Vehículo', 'Placa', 'Documentos entregados']],
      body: filas.map((f, i) => [
        i + 1,
        f.chasis || '',
        f.vehiculo || '',
        f.placa || '',
        f.documentos || ''
      ]),
      theme: 'grid',
      headStyles: { fillColor: [41, 128, 185] },
      styles: { fontSize: 8 }
    });

    let y = doc.lastAutoTable.finalY + 8;
    const totalDocs = filas.reduce(
      (a, f) => a + String(f.documentos || '').split(',').filter(x => x.trim()).length, 0);
    doc.setFontSize(9);
    doc.setFont(undefined, 'bold');
    doc.text(`Total: ${totalDocs} documento(s) de ${filas.length} chasis.`, margin, y);
    y += 10;

    if (pagos && pagos.length > 0) {
      autoTable(doc, {
        startY: y,
        head: [['Cobros de matrícula', 'Fecha', 'Valor']],
        body: pagos.map(p => [
          [p.nombres, p.apellidos].filter(Boolean).join(' '),
          p.fecha || '',
          p.valor || ''
        ]),
        theme: 'plain',
        styles: { fontSize: 8 }
      });
      y = doc.lastAutoTable.finalY + 10;
    }

    // La firma necesita ~50mm: si no caben, va en una hoja nueva (con muchos
    // chasis la tabla llega al pie y antes se dibujaba fuera de la página).
    if (y + 50 > pageHeight - margin) {
      doc.addPage();
      y = margin;
    }
    doc.setFontSize(12);
    doc.setFont(undefined, 'bold');
    doc.text('FIRMA DEL CLIENTE', margin, y + 20);
    doc.text('_________________________', margin, y + 30);
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text('Nombre y Cédula', margin, y + 38);

    doc.setFontSize(12);
    doc.setFont(undefined, 'bold');
    doc.text('SELLO DE LA EMPRESA', pageWidth - 80, y + 20);
    doc.text('_________________________', pageWidth - 80, y + 30);
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text('Fecha: _______________', pageWidth - 80, y + 38);

    doc.setFontSize(8);
    doc.text('Este documento certifica la entrega de los documentos listados al cliente identificado arriba.',
      pageWidth / 2, y + 52, { align: 'center' });

    const pdfBlob = doc.output('blob');
    return URL.createObjectURL(pdfBlob);
  }

};


export default ReporteRecepcionMatricula;
